import authStore from '../store/auth';
import { ThemeProvider } from 'styled-components';
import { theme } from '../config/theme';
import { RouterProvider } from 'react-router-dom';
import { routes } from '../router';
import { QueryClientProvider } from 'react-query';
import { privateRoutes } from '../router/private';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { queryClient } from '../config/queryClient';
import 'react-circular-progressbar/dist/styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-step-progress-bar/styles.css';
import { Toaster } from 'react-hot-toast';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import AuthenticatedProvider from './Auth';
import { SignalRProvider } from './SignalR';

const Providers = ({ children }) => {
  const _routes = useMemo(() => {
    if (authStore.token && authStore.user) return privateRoutes;

    return routes;
  }, [authStore.token, authStore.user]);

  return (
    <ThemeProvider theme={{ ...theme.light }}>
      <AuthenticatedProvider>
        <SignalRProvider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={_routes}>{children}</RouterProvider>
            <Toaster
              containerStyle={{
                zIndex: 99999999
              }}
            />
            <Tooltip opacity={1} className="tooltip-light-container" noArrow id="ligth-tooltip" />

            <Tooltip
              opacity={1}
              className="tooltip-light-container"
              noArrow
              id="right-ligth-tooltip"
              place="right"
            />
            <Tooltip place="bottom" className="tooltip-dark-container" id="dark-tooltip" noArrow />
            <Tooltip
              place="bottom"
              className="tooltip-dark-container-2"
              id="dark-tooltip-2"
              noArrow
            />
          </QueryClientProvider>
        </SignalRProvider>
      </AuthenticatedProvider>
    </ThemeProvider>
  );
};

export default observer(Providers);
